import { render, staticRenderFns } from "./BlastResults.vue?vue&type=template&id=80ff9690&scoped=true"
import script from "./BlastResults.vue?vue&type=script&lang=js"
export * from "./BlastResults.vue?vue&type=script&lang=js"
import style0 from "./BlastResults.vue?vue&type=style&index=0&id=80ff9690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ff9690",
  null
  
)

export default component.exports